<form [formGroup]="form" class="madar--v2">
  <mat-radio-group formControlName="invoiceType" class="d-flex wrap mb-3">
    <mat-radio-button class="small" color="primary" *ngFor="let option of invoiceTypeOptions" [value]="option.value" [disabled]="option.disabled">
      {{ option.label | translate }}
    </mat-radio-button>
  </mat-radio-group>
  <ng-container
    *ngIf="form.get('invoiceType')?.value === UserInvoiceType.Saas
          || form.get('invoiceType')?.value === UserInvoiceType.Both"
  >
    <mat-label class="d-block mb-0">
      {{ 'sharedFeatures.SaaSFees' | translate }}
      <span class="text-warn">*</span>
    </mat-label>
    <mat-form-field appearance="outline"  class="w-25" >
      <input matInput type="number" formControlName="fixedFees" />
      <app-icon matSuffix name="sar" size="sm"></app-icon>
      <mat-error *ngIf="form.get('fixedFees')?.hasError('required')">{{ "ErrorMessages.Required" | translate }}</mat-error>
    </mat-form-field>
  </ng-container>
</form>
